import { getFromBreakpoint, getUpToBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	reviewCount: {
		fontWeight: 'bold',
		textDecoration: 'underline',
	},
	elementContainer: {
		maxWidth: 1200,
		padding: `0 ${theme.spacing.small}`,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	accoCard: {
		backgroundColor: theme.palette.neutral[0],
		position: 'absolute',
		top: theme.spacing.small,
		left: theme.spacing.small,
		zIndex: theme.zIndex.floating,
		width: theme.accoCard.width.md,

		[getUpToBreakpoint('md')]: {
			left: 'auto',
			position: 'relative',
			top: 'auto',
			width: theme.accoCard.width.default,
		},

		'&-imageContainer': {
			height: theme.accoCard.image.height.lg,
		},

		'&-zooverdeal': {
			[getUpToBreakpoint('md')]: {
				borderTopLeftRadius: `${theme.accoCard.image.borderRadius} !important`,
				borderTopRightRadius: `${theme.accoCard.image.borderRadius} !important`,
				marginLeft: theme.spacing.small,
				marginRight: theme.spacing.small,
				marginTop: theme.spacing.small,
			},
		},
	},
	figcaption: {
		paddingBottom: theme.spacing.small,
		paddingLeft: theme.spacing.small,
		paddingRight: theme.spacing.small,
		paddingTop: theme.spacing.tiny,
	},
	mapModal: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		[getUpToBreakpoint('md')]: {
			display: 'flex',
			flexWrap: 'wrap-reverse',
		},
	},
	mapModalMapContainer: {
		width: '100%',
		height: '100%',
	},
	closeButton: {
		position: 'absolute',
		top: theme.spacing.small,
		right: theme.spacing.small,
		zIndex: theme.zIndex.floating,
	},
	contentContainer: {
		position: 'relative',
		maxWidth: '100%',
		padding: 0,
		margin: 0,
		'& > *:not(:last-child)': {
			marginBottom: theme.spacing.medium,

			[getFromBreakpoint('md')]: {
				marginBottom: theme.spacing.xlarge,
			},
		},
	},
	galleryContainer: {
		[getUpToBreakpoint('md')]: {
			padding: '0 0',
		},
	},
	overviewAndPriceBlockWrapper: {
		display: 'grid',
		gridColumnGap: theme.spacing.tiny,
		gridRowGap: theme.spacing.medium,
		gridTemplateColumns: '1fr',
		gridTemplateAreas: "'price' 'overview'",
		[getFromBreakpoint('md')]: {
			gridTemplateAreas: "'overview price'",
			gridTemplateColumns: '2fr minmax(0, 1fr)',
			gridColumnGap: theme.spacing.medium,
		},
	},
	overviewWrapper: {
		display: 'inline-block',
		gridArea: 'overview',
		'& > *:not(:last-child)': {
			marginBottom: theme.spacing.small,
			[getFromBreakpoint('md')]: {
				marginBottom: theme.spacing.xlarge,
			},
		},
	},
	priceCardWrapper: {
		gridArea: 'price',
	},
	stickyPricecard: {
		[getFromBreakpoint('md')]: {
			position: 'sticky',
			top: `calc(${theme.navbar.height} + ${theme.spacing.small})`,
		},
	},
	hasZooverDeal: {
		'&&': {
			marginBottom: 0,

			[getFromBreakpoint('md')]: {
				marginBottom: theme.spacing.xlarge,
			},
		},
	},
	infoWrapper: {
		maxWidth: theme.section.width.lg,
		margin: '0 auto',
	},
	headerWrapper: {
		marginTop: theme.spacing.small,
		[getFromBreakpoint('md')]: {
			marginTop: theme.spacing.large,
		},
	},
	contactDetails: {
		marginTop: theme.spacing.medium,
	},
	mapContainer: {
		display: 'block',
		position: 'relative',
		cursor: 'pointer',
		minHeight: '128px',
		width: '100%',
	},
	mapImage: {
		objectFit: 'cover',
	},
	openMapButton: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	adlinkPopperModalDesktop: {
		paddingLeft: theme.spacing.medium,
		paddingRight: theme.spacing.medium,
		paddingBottom: theme.spacing.medium,
	},
	noMargin: {
		marginBottom: '0 !important',
	},
}));
